<template lang="pug">
  management-page.scrollable(title="Topics"
                :creatable="false"
                :searchable="true"
                :showHeader="false")
    template(v-slot:body)
      .chart-configuration
        aiq-tooltip(v-if="isLegacyCatalog"
                    :content="$t(`${I18N_PREFIX}.legacy_catalog_tooltip`)"
                    effect="dark"
                    placement="bottom")
          .legacy-catalog-notice
            i.iq-ico-explanation
            span {{ $t(`${I18N_PREFIX}.legacy_catalog_label`) }}
        .flex-spacer
        FilteredInput.search(size="small" v-model="query" placeholder="Search")
        .time-range-filter
          aiq-date-picker(v-model="dateRange"
                          type="daterange"
                          placeholder="Select date range",
                          popper-class="metrics-time-range__date-picker-popup"
                          :shortcuts="datePickerOptions.shortcuts"
                          :disabled-date="datePickerOptions.disabledDate"
                          :teleported="false"
                          format="YYYY/MM/DD"
                          :clearable="false"
                          :default-time="getDatePickerDefaultTime()")
        aiq-button.export(@click="exportTable")
          i.iq-ico-export
      .chart-grid
          aiq-col(:span="24")
            topics-summary-table(:dateRange="dateRangeUtc"
                                 :query="searchQuery"
                                 :getReportFileName="returnReportFileName"
                                 ref="TopicsSummaryTable"
                                @algoVersionChange="onAlgoVersionChange")
</template>

<script>
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';
import dayjs from '@/localPlugins/dayjs';
import TopicsSummaryTable from './TopicsSummaryTable.vue';
import { datePickerDefaultOptions, dstDateRangeUtc, defaultDateRange, getNonReactiveDateRange, lastAvailableMonthAndQuarterRange, createPickerDateRangeOption } from '../../../configs/dateRange';
import { I18N_PREFIX, TOPICS_V1 } from './constants';


export default {
  pageResource: '/metrics/insights',
  components: {
    TopicsSummaryTable,
    ManagementPage,
  },
  computed: {
    datePickerOptions() {
      return {
        ...datePickerDefaultOptions(),
        shortcuts: lastAvailableMonthAndQuarterRange.map(createPickerDateRangeOption),
      };
    },
    dateRangeUtc() {
      const result = dstDateRangeUtc(getNonReactiveDateRange(this.dateRange));
      return result;
    },
    searchQuery() {
      return this.query;
    },
    isLegacyCatalog() {
      return this.topicsV2Enabled && this.topicsAlgoVersion === TOPICS_V1;
    },
  },

  data() {
    return {
      I18N_PREFIX,
      query: null,
      dateRange: defaultDateRange(),
      topicsAlgoVersion: TOPICS_V1,
      topicsV2Enabled: false,
    };
  },
  methods: {
    exportTable() {
      this.$refs.TopicsSummaryTable.exportTable();
    },
    returnReportFileName(chartName = 'data') {
      const [startTimestamp, endTimestamp] = this.dateRange;
      const startDate = dayjs.isDayjs(startTimestamp)
        ? startTimestamp.format('YYYY-MM-DD')
        : dayjs(startTimestamp).format('YYYY-MM-DD');
      const endDate = dayjs.isDayjs(endTimestamp)
        ? endTimestamp.format('YYYY-MM-DD')
        : dayjs(endTimestamp).format('YYYY-MM-DD');
      return `${chartName.replaceAll(' ', '_')}_${startDate}_${endDate}.csv`;
    },
    onAlgoVersionChange({ version, v2Enabled }) {
      this.topicsAlgoVersion = version;
      this.topicsV2Enabled = v2Enabled;
    },
  },
};
</script>

<style lang="scss" scoped>

.scrollable {
  height: calc(100vh - 160px);
  display: flex;
  flex-direction: column;
}

.chart-grid {
  flex: 1;

  .el-col {
    margin-bottom: 16px;
  }
}

.el-card:not(:first-of-type) {
  margin-top: 24px;
}

.chart-configuration {
  display: flex;
  margin-bottom: 12px;

  .legacy-catalog-notice {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    font-size: 12px;
    color: #909399;
    cursor: default;

    .iq-ico-explanation::before {
      width: 1rem;
      height: 1rem;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .flex-spacer {
    flex-grow: 1;
  }

   .search {
    max-width: 246px;
  }

  .time-range-filter {
    position: relative;
    margin-left: 16px;
  }

  .export-command {
    display: flex;
    height: 30px;
    width: 40px;
    justify-content: center;
    align-items: center;
    margin-left: 16px;
    padding: 0;
  }

  .el-button.export {
      height: 30px;
      width: 40px;
      padding: 0;
      margin-left: 16px;
  }
}
</style>
